<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <div style="height: 50px;padding-top: 20px;margin: 0 20px">
      <el-input v-model="searchExpireDays" prefix-icon="el-icon-search" placeholder="输入几天内到期" style="width: 150px" onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
      <el-button type="success" @click="getSearchData">查询</el-button>
    </div>
    <div style="height: calc(100% - 120px);margin: 0 20px">
      <el-table :data="tableData" border highlight-current-row ref="singleTable" height="100%">
        <el-table-column
          type="index"
          label="序号"
          width="70"
          align="center">
        </el-table-column>
        <el-table-column
          label="剩余天数"
          min-width="80"
          align="center">
          <template slot-scope="scope">
            <strong v-if="scope.row.surplusDay < 10" style="color: red;font-size: 24px">{{scope.row.surplusDay}}</strong>
            <strong v-else-if="scope.row.surplusDay < 20" style="color: #fc9d9a;font-size: 24px">{{scope.row.surplusDay}}</strong>
            <strong v-else style="color: green;font-size: 24px">{{scope.row.surplusDay}}</strong>
          </template>
        </el-table-column>
        <el-table-column
          prop="person_name"
          label="老人姓名"
          min-width="120"
          align="center">
        </el-table-column>
        <el-table-column
          label="老人性别"
          min-width="80"
          align="center">
          <template slot-scope="scope">
            <span>{{getSexDesc(scope.row.sex)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="老人生日"
          width="100"
          align="center">
          <template slot-scope="scope">
            <span>{{scope.row.birthday}}</span>
            <br>
            <span>{{getAgeDesc(scope.row.birthday)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="所在床位"
          min-width="150"
          align="center">
          <template slot-scope="scope">
            <span>{{getBedDesc(scope.row)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="是否失能"
          min-width="80"
          align="center">
          <template slot-scope="scope">
            <span>{{getDisabledElderlyDesc(scope.row.disabled_elderly)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="照护等级"
          min-width="80"
          align="center">
          <template slot-scope="scope">
            <span>{{getCareLevelDesc(scope.row.care_level)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="diet_level"
          label="饮食级别"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop="esp_name"
          label="办理人员"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          label="入住时间"
          width="100"
          align="center">
          <template slot-scope="scope">
            <span>{{getTimeDesc(scope.row.create_time)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="退住时间"
          width="100"
          align="center">
          <template slot-scope="scope">
            <span>{{getTimeDesc(scope.row.leave_time)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="状态"
          min-width="80"
          align="center">
          <template slot-scope="scope">
            <span>{{getCurentStateDesc(scope.row.curent_state)}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px;height: 40px;text-align: center">
      <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                     :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                     layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {queryhomebedelderly} from '../../api/yanglaoyuan/homebed'

export default {
  name: 'deadlineWarn',
  data () {
    return {
      entityId: 0,
      searchExpireDays: '90',
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      stateTypeArr: [{id: 0, name: '正常'}, {id: 1, name: '请假'}, {id: 2, name: '申请退住'}],
      careLevelArr: [],
      tableData: []
    }
  },
  created () {
    this.entityId = this.$store.state.user.LoginResp.entity_id
    this.careLevelArr = this.commonType.getCareLevelArr()
    this.getSearchData()
  },
  methods: {
    getSearchData () {
      this.getHomebedElderlyData()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getSearchData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getSearchData()
    },

    // table显示
    // 获取剩余天数
    getSurplusDay (leaveTime) {
      let surplusDay = 0
      let now = new Date()
      let leave = new Date(leaveTime)
      surplusDay = (leave.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)
      return Math.floor(surplusDay)
    },
    // 获取性别描述
    getSexDesc (sex) {
      return this.util.getSex(sex)
    },
    // 获取年龄描述 ****-**-**/age
    getAgeDesc (birthDate) {
      let result = ''
      let age = this.util.getAgeByBirth(birthDate)
      if (age === '') {
        result = '--'
      } else {
        result = age + '岁'
      }
      return result
    },
    // 获取所在床位
    getBedDesc (row) {
      let result = ''
      result = row.build_name + '/' + row.floor_name + '/' + row.room_name + '/' + row.bed_name
      return result
    },
    // 获取失能状态描述
    getDisabledElderlyDesc (disabledElderly) {
      let result = '否'
      if (disabledElderly === '1') {
        result = '是'
      }
      return result
    },
    // 获取护理等级描述
    getCareLevelDesc (careLevel) {
      let result = '未知'
      let careLevelObj = this.careLevelArr.find(r => r.id === careLevel.toString())
      if (careLevelObj) {
        result = careLevelObj.name
      }
      return result
    },
    // 获取居住状态描述
    getCurentStateDesc (curentState) {
      let result = ''
      let stateType = this.stateTypeArr.find(r => r.id === parseInt(curentState))
      if (stateType) {
        result = stateType.name
      }
      return result
    },
    getTimeDesc (time) {
      let dateTime = new Date(time)
      return dateTime.format('yyyy-MM-dd')
    },

    // 访问接口
    // 查询入院列表
    getHomebedElderlyData () {
      let that = this
      this.tableData = []
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      let expireDays = 7
      if (this.searchExpireDays !== '') {
        expireDays = parseInt(this.searchExpireDays)
      }

      let data = {
        eid: this.entityId === 0 ? -1 : this.entityId,
        expire_flag: 1,
        expire_days: expireDays
      }
      queryhomebedelderly(params, data).then(res => {
        this.totalCells = res.data.cnt
        this.tableData = res.data.homebedperson
        this.tableData.forEach(item => {
          item.surplusDay = that.getSurplusDay(item.leave_time)
        })
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/deadlineWarn.vue